import {css, tokens} from '@sail/ui';
import {helmTokens} from '@sail/helm';

export const styles = {
  container: css({
    display: 'grid',
    position: 'relative',
    gridColumn: '1/-1',
    gridTemplateColumns: 'repeat(4, 1fr)',
    marginTop: `${tokens.space.large}`,
    paddingTop: `${tokens.space.xlarge}`,
    ':before': {
      content: '""',
      position: 'absolute',
      top: 'space.1',
      left: 'space.0',
      zIndex: '1',
      width: 'fill',
      height: 'space.1',
      background: `linear-gradient(90deg, ${helmTokens.color.gridLines.dashed}, ${helmTokens.color.gridLines.dashed} 50%, transparent 0, transparent)`,
      backgroundSize: '8px 1px',
    },
  }),
  content: css({
    gridColumnStart: '2',
    gridColumn: '1/-1',
  }),

  disclaimerList: css({
    stack: 'y',
    gap: 'xsmall',
    font: 'body.small',
    textColor: tokens.color.neutral[600],
    listStyleType: 'none',
    padding: 'space.0',
    paddingLeft: 'medium',
    margin: 'space.0',
  }),
  disclaimerListUnprocessed: css({
    letterSpacing: `${helmTokens.letterSpacing.large}`,
  }),
};
